import React, { ReactNode } from "react";
import styled from "styled-components";

import { colors } from "../../../styles/variables";

/* Page wrapper for routes that don't render inside <Layout> — auth
 * (login / signup / password reset), the quizzes, the welcome-pack
 * picker, and checkout. Provides the same notch handling as Layout
 * does for its `.content`:
 *
 *   - A fixed-position TopInsetSpacer paints the safe-area inset zone
 *     in the page's chosen colour (default white).
 *   - The outer flex column adds padding-top: env(safe-area-inset-top)
 *     so the page's leading element starts below the spacer instead of
 *     having to fold env() into its own padding.
 *
 * Pages whose first flow element is a coloured header (or hero) pass
 * its bg via `topBg` so the inset zone matches it. env() = 0 on web
 * so this is inert there. */

const Spacer = styled.div<{ $bg: string }>`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  height: env(safe-area-inset-top);
  background-color: ${(props) => props.$bg};
  z-index: 5000;
  pointer-events: none;
`;

const Outer = styled.div`
  display: flex;
  flex-direction: column;
  min-height: 100vh;
  padding-top: env(safe-area-inset-top);
`;

interface FullscreenLayoutProps {
  /** Background colour for the safe-area inset zone. Defaults to white. */
  topBg?: string;
  /** Page content. */
  children: ReactNode;
  /** styled-components extension hook. */
  className?: string;
}

const FullscreenLayout = ({ topBg = colors.white, children, className }: FullscreenLayoutProps) => (
  <>
    <Spacer $bg={topBg} />
    <Outer className={className}>{children}</Outer>
  </>
);

export default FullscreenLayout;
